






























































































import Vue from 'vue';
import { Getter } from 'vuex-class';
import Component, { mixins } from 'vue-class-component';
import _ from 'lodash';
import { HeaderTable, InjectionCycleType } from './types';
import VaccinationTableBtns from '@/components/Vaccination/VaccinationTableBtns/VaccinationTableBtns.vue';
import PopInCloseVaccination from '@/components/BandeauCycle/PopinBandeauCycle/PopInCloseVaccination.vue';
import { VaccinationFolder } from '@/store/folder/types';

const Props = Vue.extend({
	props: {
		injectionsHeaders: {
			type: Array as () => HeaderTable[],
			required: true
		},
		injectionsList: {
			type: Array as () => InjectionCycleType[],
			required: true
		},
		eventPrevisionnels: {
			type: Array as () => InjectionCycleType[],
			required: true
		}
	}
});

@Component({
	components: {
		VaccinationTableBtns,
		PopInCloseVaccination
	}
})
export default class TableauInjectionsCycle extends mixins(Props) {
	@Getter('infosVaccinationFolder/getVaccinationFolder') folder!: VaccinationFolder;

	popinCloseCycle = false;

	isTruncate(origin: string, tailleMax: number) {
		return _.size(origin) > tailleMax;
	}

	truncate(origin: string, tailleMax: number): string {
		return _.truncate( origin, { length: tailleMax + 3, omission: '...' });
	}

	injectionsSearch(row: InjectionCycleType) {
		this.$emit('injectionsSearch', row.injection);
	}

	injectionsEdit(row: InjectionCycleType) {
		this.$emit('injectionsEdit', row.injection);
	}

	get getNumeroBon(): string | undefined {
		return _.get(this.folder, 'numeroBon');
	}

}
